export default "__VITE_ASSET__Dy6S66Zu__"